import React, { useState } from 'react';
import { TherapyTimeInterval } from '@lmt/signal-viewer-ui';
import { useDayNavigation } from '../contexts/DayNavigationContext';
import './TimeIntervalSwitcher.css';

export const TimeIntervalSwitcher: React.FC = () => {
  const { onTimeIntervalToggle } = useDayNavigation();
  const [selected, setSelected] = useState(TherapyTimeInterval.TherapyDay);

  return (
    <div className='switcher-container'>
      <button
        className={`switcher-option ${selected === TherapyTimeInterval.TherapyDay ? 'active' : ''}`}
        onClick={() => {
          if (selected === TherapyTimeInterval.TherapyDay) {
            return;
          }
          setSelected(TherapyTimeInterval.TherapyDay);
          onTimeIntervalToggle();
        }}
      >
        <div className='option-title'>Therapy Day</div>
      </button>

      <button
        className={`switcher-option ${selected === TherapyTimeInterval.CalendarDay ? 'active' : ''}`}
        onClick={() => {
          if (selected === TherapyTimeInterval.CalendarDay) {
            return;
          }
          setSelected(TherapyTimeInterval.CalendarDay);
          onTimeIntervalToggle();
        }}
      >
        <div className='option-title'>Calendar Day</div>
      </button>
    </div>
  );
};
